<template>
  <div id="wt-home">Select a panel to start navigation</div>
</template>

<script>
export default {
  name: "HomeContainer",
  components: {},

  data: function() {
    return {};
  },
  methods: {},
  watch: {},
  created() {
    this.$store.commit("setTypeLayout", 3);
  }
};
</script>